import styled from 'styled-components';

export const StyledUnderline = styled.span`
  position: relative;
  display: inline-block;
  
  &::before {
    content: '';
    background-color: var(--color-underline);
    position: absolute;
    left: -2px;
    bottom: .15em;
    width: calc(100% + 4px);
    height: .3em;
    z-index: -1;
    transition: background-color var(--theme-transition-duration);
  }
`;